import axios from 'axios';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';





const CUETSubjectModal = forwardRef((props, ref) => {
    const [modalBox, setModalBox] = useState(false);
    let initialData = {
        SubjectType: '',
        ExamType: 'Select All SUBJECT',
    }


    const [examBodyData, setExamBodyData] = useState(initialData);


    console.log(examBodyData);
    useImperativeHandle(ref, () => ({
        openModal(item = {}) {
            if (item.Sn > 0) {
                setExamBodyData(item)
                // Assuming setSelectedSubjects and subjects are defined elsewhere or will be added
                // setSelectedSubjects(subjects.filter((subject) => subject.ExamType === item.ExamType));
            } else {
                setExamBodyData({ ...initialData, ...item });
                if (item.ExamType) {
                    // Assuming setSelectedSubjects and subjects are defined elsewhere or will be added
                    // setSelectedSubjects(subjects.filter((subject) => subject.ExamType === item.ExamType));
                }
            }
            setModalBox(true);

        }
    }));

    const hanldeSaveExamBody = async () => {
        try {
            if (examBodyData.SubjectType.trim().length === 0) {
                toast.error("Please Enter question type")
                return;
            } else if (examBodyData.ExamType.trim().length === 0 || examBodyData.ExamType === 'Select Subject Type') {
                toast.error("Please select Subject type")
                return;
            }
            const response = axios.post(BACKEND_SERVER_URL + `${!examBodyData.Sn ? '/cuet/createSubject' : `/cuet/updateSubject`}`, examBodyData);
            console.log(response)
            toast.success(response.data.message);
            props.setSubjectLoading(!props.loadSubjects);

        } catch (error) {
            console.log(error)
            toast.error(error?.response?.data?.message)
        } finally {
            props.setSubjectLoading(!props.loadSubjects);
            setExamBodyData(initialData)
            setModalBox(false);
            setExamBodyData(initialData);
        }

    }

    return (
        <>
            <Modal onHide={setModalBox} show={modalBox} size="md" backdrop="static"
                keyboard={false} >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel"> {examBodyData.Sn ? "Update SUBJECT NAME" : "Add SUBJECT NAME"}</h5>
                        <button type="button" className="btn-close" onClick={() => setModalBox(false)}></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <label htmlFor="sessioncount" className="form-label text-primary">All SUBJECT<span className="required">*</span></label>
                            <Select
                                value={(() => {
                                    const options = [
                                        { value: 'Section-IA', label: 'Language Subjects' },
                                        { value: 'Section-II', label: 'Domain-Specific Subjects' },
                                        { value: 'Section-III', label: 'General Aptitude Test' }
                                    ];
                                    return options.find(opt => opt.value === examBodyData.ExamType) || { value: examBodyData.ExamType, label: examBodyData.ExamType };
                                })()}
                                onChange={(selectedOption) => setExamBodyData({ ...examBodyData, ExamType: selectedOption.value })}
                                options={[
                                    { value: 'Section-IA', label: 'Language Subjects' },
                                    { value: 'Section-II', label: 'Domain-Specific Subjects' },
                                    { value: 'Section-III', label: 'General Aptitude Test' }
                                ]}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        width: '100%',
                                        backgroundColor: 'transparent', // Adjust as needed
                                        borderColor: '#17a2b8', // Adjust as needed

                                    }),
                                }}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="subjects" className="form-label text-primary">SUBJECT NAME<span className="required">*</span></label>
                            <input autoFocus className='form-control' type="text" name="" id="subjects" value={examBodyData.SubjectType} onChange={(e) => setExamBodyData({ ...examBodyData, SubjectType: e.target.value })} />
                        </div>



                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger btn-xs" onClick={() => setModalBox(false)}>Close</button>
                        <button type="button" className="btn btn-primary btn-xs " onClick={hanldeSaveExamBody}>{examBodyData.Sn ? "Update" : "Add"}</button>
                    </div>
                </div>
            </Modal>

        </>
    )
})
export default CUETSubjectModal;